import {NgModule} from '@angular/core';

import {RequestSummaryControlComponent} from './request-summary-control.component';
import {LanguageModule} from '../../language/language.module';
import {CommonModule} from '@angular/common';
import {PipesModule} from '../pipes/pipes.module';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {FormsModule} from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTableModule} from '@angular/material/table';
import {MatChipsModule} from '@angular/material/chips';
import {MatButton} from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    LanguageModule,
    PipesModule,
    FormsModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatChipsModule,
    MatButton,
  ],
  declarations: [RequestSummaryControlComponent],
  exports: [RequestSummaryControlComponent],
})
export class SharedControlsModule {}
